module.exports = __webpack_public_path__ + "static/media/close.7082e21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RenewResubscriptionModal/close.svg
// module id = 323
// module chunks = 0